import { ErrorMessage, FormField, Input, Layout, Select } from "@vwfs-bronson/bronson-react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { IPersonalData } from "../../interfaces";
import { BrandType, PhoneCountryCodeType } from "@bus/models";

export const PersonalData = () => {
    const brand = process.env.REACT_APP_WEBSITE_BRAND;
    const { t } = useTranslation(["personalinformation"]);
    const { errors, setFieldValue, getFieldProps, touched } = useFormikContext<IPersonalData>();
    const handleChangeInputNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.value) {
            setFieldValue("mobilePhoneNumber", "", true);
        } else if (isNaN(Number(event.target.value)) || event.target.value.includes(".")) {
            return;
        } else {
            setFieldValue("mobilePhoneNumber", event.target.value, true);
        }
    };
    return (
        <Layout>
            <Layout.Item>
                <p className="u-mt-xlarge">{brand === "audi" ? t("personalinformation:personal-data-section.titleAudi"): t("personalinformation:personal-data-section.title")}</p>
            </Layout.Item>
            <Layout.Item default="1/2">
                <FormField
                    labelForId="test-form-input"
                    labelText={t("personalinformation:personal-data-section.input-name")}
                    type="input"
                    noFloatingLabel
                >
                    <Input
                    aria-invalid={!!(touched["firstName"] && errors["firstName"])}
                    aria-errormessage={`${"firstName"}`}
                    {...getFieldProps("firstName")} id="firstName" noBackground required autoComplete="given-name"/>
                </FormField>
                {touched["firstName"] && errors["firstName"] && (
                    <Layout>
                        <Layout.Item>
                            <ErrorMessage id={`${"firstName"}`}>{errors["firstName"] as string}</ErrorMessage>
                        </Layout.Item>
                    </Layout>
                )}
            </Layout.Item>
            <Layout.Item default="1/2">
                <FormField
                    labelForId="test-form-input"
                    labelText={t("personalinformation:personal-data-section.input-surname")}
                    type="input"
                    noFloatingLabel
                >
                    <Input aria-invalid={!!(touched["lastName"] && errors["lastName"])} aria-errormessage={`${"lastName"}`} {...getFieldProps("lastName")} id="lastName" noBackground required autoComplete="family-name"/>
                </FormField>
                {touched["lastName"] && errors["lastName"] && (
                    <Layout>
                        <Layout.Item>
                            <ErrorMessage id={`${"lastName"}`}>{errors["lastName"] as string}</ErrorMessage>
                        </Layout.Item>
                    </Layout>
                )}
            </Layout.Item>

            <Layout.Item default="1/2">
                <FormField
                    labelForId="test-form-input"
                    labelText={t("personalinformation:personal-data-section.input-phone-number")}
                    type="input"
                    noFloatingLabel
                >
                    <Layout>
                        <Layout.Item default={brand === BrandType.SKODA ? "2/6" : "1/6"}>
                            <Select
                            aria-invalid={!!(touched["mobilePhoneCountryCode"] && errors["mobilePhoneCountryCode"])}
                            aria-errormessage={`${"mobilePhoneCountryCode"}`}
                            {...getFieldProps("mobilePhoneCountryCode")} id="mobilePhoneCountryCode">
                                <>
                                    {Object.values(PhoneCountryCodeType).map((x: PhoneCountryCodeType, index) => {
                                        return (
                                            <Select.Item key={"countryCode_" + index} value={x}>
                                                {x}
                                            </Select.Item>
                                        );
                                    })}
                                </>
                            </Select>
                        </Layout.Item>
                        <Layout.Item default={brand === BrandType.SKODA ? "4/6" : "5/6"}>
                            <Input
                                aria-invalid={!!(touched["mobilePhoneNumber"] && errors["mobilePhoneNumber"])}
                                aria-errormessage={`${"mobilePhoneNumber"}`}
                                {...getFieldProps("mobilePhoneNumber")}
                                id="mobilePhoneNumber"
                                noBackground
                                onChange={handleChangeInputNumber}
                                type="text"
                                required
                                autoComplete="tel-national"
                            />
                        </Layout.Item>
                    </Layout>
                </FormField>
                {touched["mobilePhoneNumber"] && errors["mobilePhoneNumber"] && (
                    <Layout>
                        <Layout.Item>
                            <ErrorMessage id={`${"mobilePhoneNumber"}`}>
                                {errors["mobilePhoneNumber"] as string}
                            </ErrorMessage>
                        </Layout.Item>
                    </Layout>
                )}
                {touched["mobilePhoneCountryCode"] && errors["mobilePhoneCountryCode"] && (
                    <Layout>
                        <Layout.Item>
                            <ErrorMessage id={`${"mobilePhoneCountryCode"}`}>
                                {errors["mobilePhoneCountryCode"] as string}
                            </ErrorMessage>
                        </Layout.Item>
                    </Layout>
                )}
            </Layout.Item>

            <Layout.Item default="1/2">
                <FormField
                    labelForId="test-form-input"
                    labelText={t("personalinformation:personal-data-section.input-email")}
                    type="input"
                    noFloatingLabel
                >
                    <Input 
                    aria-invalid={!!(touched["email"] && errors["email"])}
                    aria-errormessage={`${"email"}`}
                    {...getFieldProps("email")} id="email" noBackground required autoComplete="email"/>
                </FormField>
                {touched["email"] && errors["email"] && (
                    <Layout>
                        <Layout.Item>
                            <ErrorMessage id={`${"email"}`}>{errors["email"] as string}</ErrorMessage>
                        </Layout.Item>
                    </Layout>
                )}
            </Layout.Item>
        </Layout>
    );
};
